import { Link } from "react-router-dom";
import { ArrowUpRight, ScrollText } from "lucide-react";
import { Button } from "@/components/ui/button";

export const PatchNotesButton = ({ testId, to = "/changelog" }) => (
  <Button asChild size="lg" className="h-auto min-h-14 w-full sm:w-auto px-7 py-4 rounded-lg bg-purple-600 text-white hover:bg-purple-500 focus-visible:ring-purple-300 text-base font-semibold shadow-[0_4px_24px_rgba(147,51,234,0.25)] transition-colors">
    <Link to={to} data-testid={testId}>
      <ScrollText className="h-5 w-5 mr-2" /> Patch Notes <ArrowUpRight className="h-5 w-5 ml-3" />
    </Link>
  </Button>
);